"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: passkey/passkey-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fpasskey%2Fpasskey-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasskeyServiceClient = exports.RevokePasskeyResponse = exports.RevokePasskeyRequest = exports.GetPasskeysResponse = exports.GetPasskeysRequest = exports.FinishRegistrationResponse = exports.FinishRegistrationRequest = exports.StartRegistrationResponse = exports.StartRegistrationRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const passkey_1 = require("./passkey");
const protobufPackage = 'com.step.passkey.proto';
function createBaseStartRegistrationRequest() {
    return { displayName: '', name: '' };
}
exports.StartRegistrationRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.displayName)) {
            message.displayName = globalThis.String(object.displayName);
        }
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.displayName !== undefined && message.displayName !== '') {
            obj.displayName = message.displayName;
        }
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        return obj;
    },
    create(base) {
        return exports.StartRegistrationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStartRegistrationRequest();
        message.displayName = object.displayName ?? '';
        message.name = object.name ?? '';
        return message;
    },
};
function createBaseStartRegistrationResponse() {
    return { challengeJson: '' };
}
exports.StartRegistrationResponse = {
    fromJSON(object) {
        const message = {
            challengeJson: isSet(object.challengeJson) ? globalThis.String(object.challengeJson) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.challengeJson !== '') {
            obj.challengeJson = message.challengeJson;
        }
        return obj;
    },
    create(base) {
        return exports.StartRegistrationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStartRegistrationResponse();
        message.challengeJson = object.challengeJson ?? '';
        return message;
    },
};
function createBaseFinishRegistrationRequest() {
    return { publicKeyCredentialJson: '' };
}
exports.FinishRegistrationRequest = {
    fromJSON(object) {
        const message = {
            publicKeyCredentialJson: isSet(object.publicKeyCredentialJson)
                ? globalThis.String(object.publicKeyCredentialJson)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.publicKeyCredentialJson !== '') {
            obj.publicKeyCredentialJson = message.publicKeyCredentialJson;
        }
        return obj;
    },
    create(base) {
        return exports.FinishRegistrationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFinishRegistrationRequest();
        message.publicKeyCredentialJson = object.publicKeyCredentialJson ?? '';
        return message;
    },
};
function createBaseFinishRegistrationResponse() {
    return { passkey: passkey_1.Passkey.fromPartial({}) };
}
exports.FinishRegistrationResponse = {
    fromJSON(object) {
        const message = {
            passkey: isSet(object.passkey) ? passkey_1.Passkey.fromJSON(object.passkey) : passkey_1.Passkey.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.passkey !== undefined) {
            obj.passkey = passkey_1.Passkey.toJSON(message.passkey);
        }
        return obj;
    },
    create(base) {
        return exports.FinishRegistrationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFinishRegistrationResponse();
        message.passkey = (object.passkey !== undefined && object.passkey !== null)
            ? passkey_1.Passkey.fromPartial(object.passkey)
            : passkey_1.Passkey.fromPartial({});
        return message;
    },
};
function createBaseGetPasskeysRequest() {
    return {};
}
exports.GetPasskeysRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetPasskeysRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetPasskeysRequest();
        return message;
    },
};
function createBaseGetPasskeysResponse() {
    return { passkeys: [] };
}
exports.GetPasskeysResponse = {
    fromJSON(object) {
        const message = {
            passkeys: globalThis.Array.isArray(object?.passkeys)
                ? object.passkeys.map((e) => passkey_1.Passkey.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.passkeys?.length) {
            obj.passkeys = message.passkeys.map((e) => passkey_1.Passkey.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetPasskeysResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPasskeysResponse();
        message.passkeys = object.passkeys?.map((e) => passkey_1.Passkey.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRevokePasskeyRequest() {
    return { passkeyId: '' };
}
exports.RevokePasskeyRequest = {
    fromJSON(object) {
        const message = {
            passkeyId: isSet(object.passkeyId) ? globalThis.String(object.passkeyId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.passkeyId !== '') {
            obj.passkeyId = message.passkeyId;
        }
        return obj;
    },
    create(base) {
        return exports.RevokePasskeyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRevokePasskeyRequest();
        message.passkeyId = object.passkeyId ?? '';
        return message;
    },
};
function createBaseRevokePasskeyResponse() {
    return {};
}
exports.RevokePasskeyResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RevokePasskeyResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRevokePasskeyResponse();
        return message;
    },
};
/**
 * Passkey Public API.
 */
class PasskeyServiceClient {
    rpc;
    name = 'com.step.passkey.proto.PasskeyService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/passkey';
    methods = [{
            name: 'StartRegistration',
            requestType: exports.StartRegistrationRequest,
            responseType: exports.StartRegistrationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'FinishRegistration',
            requestType: exports.FinishRegistrationRequest,
            responseType: exports.FinishRegistrationResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
            adminTokenType: undefined,
        }, {
            name: 'GetPasskeys',
            requestType: exports.GetPasskeysRequest,
            responseType: exports.GetPasskeysResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'RevokePasskey',
            requestType: exports.RevokePasskeyRequest,
            responseType: exports.RevokePasskeyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    startRegistration(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    finishRegistration(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getPasskeys(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    revokePasskey(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.PasskeyServiceClient = PasskeyServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=passkey-service.js.map